import { Box, Flex } from '@talos/kyoko';
import styled from 'styled-components';

export const InstrumentCell = styled(Box)`
  flex: 0 1 auto;
  min-width: 0;
`;

export const WarningCell = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
`;

export const MarketAccountText = styled(Box)`
  flex: 0 10 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colorTextSubtle};
  text-transform: uppercase;
  margin-right: auto;

  & > * {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  span,
  div {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const CardMetrics = styled(Flex)`
  justify-content: space-between;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing12}px;
`;

export const CardMetricWrapper = styled(Flex)`
  flex-direction: column;
  flex: 1 0 auto;
  min-width: 0;
  gap: ${({ theme }) => theme.spacing2}px;

  &:not(:first-child) {
    align-items: flex-end;
    text-align: right;
  }

  & > * {
    min-width: 0;
    max-width: 100%;
  }
`;

export const GroupMetricWrapper = styled(Flex)`
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing2}px;
  overflow: hidden;

  /* Hide label + value when the cell renderer produced no DOM children (e.g. AgGridSize -> <></>). */
  &:has(.group-metric-value:empty) {
    display: none;
  }
`;
